export default __webpack_public_path__ + "static/media/fleet_group_truck.4e1b9225.svg";